import * as Types from '../../../__generated__/schema';

import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
export type DataSchemaTeaser = Pick<
  Types.Schema,
  | 'name'
  | 'description'
  | 'createdAt'
  | 'updatedAt'
  | 'isArchived'
  | 'isManaged'
  | 'isFieldDiscoveryEnabled'
> & {
  logSources?: Types.Maybe<
    Array<
      | Pick<Types.AmazonSecurityLakeLogIntegration, 'integrationId' | 'integrationLabel'>
      | Pick<Types.AzureBlobSourceIntegration, 'integrationId' | 'integrationLabel'>
      | Pick<Types.AzureEventHubSourceIntegration, 'integrationId' | 'integrationLabel'>
      | Pick<Types.CloudWatchLogIntegration, 'integrationId' | 'integrationLabel'>
      | Pick<Types.EventBridgeIntegration, 'integrationId' | 'integrationLabel'>
      | Pick<Types.GcpPubSubLogSourceIntegration, 'integrationId' | 'integrationLabel'>
      | Pick<Types.GcsLogSourceIntegration, 'integrationId' | 'integrationLabel'>
      | Pick<Types.HttpLogSourceIntegration, 'integrationId' | 'integrationLabel'>
      | Pick<Types.LogForwarderLogSourceIntegration, 'integrationId' | 'integrationLabel'>
      | Pick<Types.LogPullingIntegration, 'integrationId' | 'integrationLabel'>
      | Pick<Types.OTLPLogSourceIntegration, 'integrationId' | 'integrationLabel'>
      | Pick<Types.S3LogIntegration, 'integrationId' | 'integrationLabel'>
      | Pick<Types.SqsLogSourceIntegration, 'integrationId' | 'integrationLabel'>
    >
  >;
};

export const DataSchemaTeaser = gql`
  fragment DataSchemaTeaser on Schema {
    name
    description
    createdAt
    updatedAt
    isArchived
    isManaged
    isFieldDiscoveryEnabled
    logSources {
      integrationId
      integrationLabel
    }
  }
`;
